import { render, staticRenderFns } from "./FontForm.vue?vue&type=template&id=9a34d678"
import script from "./FontForm.vue?vue&type=script&lang=js"
export * from "./FontForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports